var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-icon-wrapper",class:{ 'loading-icon-wrapper__full': !_vm.inline }},[_c('v-progress-circular',_vm._b({attrs:{"indeterminate":!_vm.progress,"value":_vm.progress,"color":_vm.colour}},'v-progress-circular',_vm.$attrs,false),[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }